<template>
    <div>
        <b-tabs content-class="mt-3">
            <b-tab title="Administración de Menus" active>
                <app-permission-manager-page />
            </b-tab>
            <b-tab title="Permisos">
                <app-capabilities-manager-page />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import PermissionManagerPage from '../PermissionManager/PermissionManagerPage';
import CapabilitiesManagerPage from '../CapabilitiesManager/CapabilitiesManagerPage';
export default {
    name: 'security_manager',
    components: {
        appPermissionManagerPage: PermissionManagerPage,
        appCapabilitiesManagerPage: CapabilitiesManagerPage,
    }
}
</script>